/**
 * date：2022-05-10
 * author：brian
 * 用途：获取完成的属性地址 搭配全局的search使用
 */

const mixin = {
    data() {
        return {
            treePathObj: '',
        }
    },
    methods: {
        getAllPath(row) {
            if (row.id !== 'all') {

                let treeArray = this.$store.getters.SchemaTree
                let arr = this.$getParent(treeArray, row.sceneCode, 'sceneCode').map((item) => {
                    return item.label
                })
                this.treePathObj = arr.join(',').replace(/,/g, ' / ');
            }
        }
    }
}

export default mixin